module.exports = "/static/assets/3cac0342b766442b1fbc630983c13950.png";